import * as React from 'react';

import { translate } from '~l10n/client';

import { FeatureUseEventAdapter } from '~analytics/adapters/FeatureUseEventAdapter';
import { useInviteStudentsDrawerDispatch } from '~teacher/components/ActivityResult/modals/InviteStudentDrawer';

interface Props {
  finishClicked: () => void;
}

export function SpaceRaceHeader({ finishClicked }: Props) {
  const dispatch = useInviteStudentsDrawerDispatch();

  const handleInviteStudents = () => {
    new FeatureUseEventAdapter({
      feature: 'invite_student_drawer',
      action: 'open',
      source: 'space_race_header',
    }).sendAnalytics();
    dispatch('Open');
  };

  return (
    <div className="space-race-header flex justify-around pt-8 px-3 gap-3">
      <div className="flex content-center flex-wrap">
        <span
          className="space-race-header-text"
          style={{ whiteSpace: 'nowrap' }}
        >
          {translate('Space Race')}
        </span>
      </div>
      <div className="flex flex-wrap justify-end gap-4">
        <button
          className="button button-primary button-small pill space-race-finish-button"
          onClick={handleInviteStudents}
        >
          {translate('Invite Students')}
        </button>
        <button
          className="button button-primary button-small pill space-race-finish-button"
          onClick={finishClicked}
        >
          {translate('Finish')}
        </button>
      </div>
    </div>
  );
}
